class PermitService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/document/permits';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ permit }) {
    const { data } = await this.axios.post(this.url, permit);
    return data;
  }

  async upload({ id, formData }) {
    const { data } = await this.axios.put(`${this.url}/upload/${id}`, formData);
    return data;
  }

  async update({ permit }) {
    const { data } = await this.axios.put(this.url, permit);
    return data;
  }

  async archive({ permit }) {
    const { _id: id } = permit;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: permit });
    return data;
  }
}

export default PermitService;
